

























import ClientInterviewDataForm from "@/components/ebs/ClientInterviewDataForm.vue";
import EsiaClientDataConfirm from "@/components/ebs/EsiaClientDataConfirm.vue";
import { Http } from "fs-pb-vue2/services/api/http";
import { clientTime } from "fs-pb-vue2/utilities";
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { AppStore } from "fs-pb-vue2/store/modules/app";

@Component({ components: { EsiaClientDataConfirm, ClientInterviewDataForm } })
export default class EbsEsia extends Vue {
  get appStore(): AppStore {
    return getModule(AppStore, this.$store);
  }
  dialog: boolean = true;
  /**0 - new 1 accept 2 interview */
  step: number = 0;
  errorText: string = "";
  isError: boolean = false;
  clientData: any = {};
  get isAccept(): boolean {
    return this.step == 1;
  }

  get isInterview(): boolean {
    return this.step == 2;
  }

  async mounted(): Promise<void> {
    console.log(this.$route.query)
    const error: any = this.$route.query["error"];
    let error_description: any = this.$route.query["error_description"];
    const code: any = this.$route.query["code"];
    const cmd: any = this.$route.query["cmd"];
    console.log(error_description)
    if (error_description) {
      error_description = decodeURIComponent(error_description)

      if (error_description.includes('ESIA-007014'))
        this.errorText = 'Произошла ошибка при выполнении операции. Попробуйте позже или обратитесь в банк';
      else if (error_description.includes('EBS-010301'))
        this.errorText = 'К сожалению, вы еще не зарегистрировали цифровой образ';
      else if (error_description.includes('ESIA-007004'))
        this.errorText = 'К сожалению, без доступа к данным продолжить невозможно';
      else
        this.errorText = error_description;

      this.isError = true;
    } else if (code) {
      if (cmd == "initesia") {
        await this.afterInitEsia(code);
      } else {
        await this.getUserData(code);
      }
    } else {
      this.isError = true;
      this.errorText = "Произошла ошибка, попробуйте повторить операцию позднее."
    }
  }

  toMain(): void {
    this.$router.push("/");
  }

  async afterInitEsia(code: string): Promise<void> {
    this.appStore.setLoading(true);

    try {
      const resp = await Http.get(`EbsEsia/FindClient?sessionId=${code}&clientTime=${clientTime()}&source=0`);

      if (resp.result == "error") {
        this.isError = true;
        this.errorText = resp.message;
      } else {
        await this.getEbsLink();
      }
    } catch (e) {
      this.isError = true;
      this.errorText = e;
    }
    this.appStore.setLoading(false);

  }

  async getEbsLink(): Promise<void> {
    this.appStore.setLoading(true);

    try {
      const resp = await Http.get(`EbsEsia/Init?clientTime=${clientTime()}&source=0`);
      if (resp.result === 'ok') {
        this.appStore.setLoading(false);

        const linkAuth = resp.data.link;
        window.location.href = linkAuth;
      }
      else {
        this.$router.push(`/ebsesia?error=${resp.message}&error_descriptiom=${resp.message}`)
      }
    } catch (e) {
      this.isError = true;
      this.errorText = e;
    }

    this.appStore.setLoading(false);
  }

  async getUserData(code: string): Promise<void> {
    this.appStore.setLoading(true);
    try {
      const resp = await Http.get(`EbsEsia/GetResult?sessionId=${code}&clientTime=${clientTime()}&source=0`);

      if (resp.result == "error") {
        this.isError = true;
        this.errorText = resp.message;
      } else {
        this.clientData = JSON.parse(resp.data.clientData);
        this.step = 1;
      }
    } catch (e) {
      this.isError = true;
      this.errorText = e;
    }
    this.appStore.setLoading(false);
  }

  openQuestionnaire(): void {
    this.step = 2;
  }

  finished(message: string) {
    this.isError = true;
    this.errorText = message;
  }
}
